<!-- Start Navbar -->
<nav dir='rtl' class='navbar navbar-expand-lg'>
  <div class='container'>
    <a class='navbar-brand' routerLink='/ar'>
      <img src='../../assets/images/logo.svg' alt='' class='img-fluid'>
    </a>
    <a href='tel:+201001040090' dir='ltr' class='btn tel d-lg-none d-block'>01001040090</a>
    <button class='navbar-toggler' type='button' data-toggle='collapse' data-target='#navbarSupportedContent'
      aria-controls='navbarSupportedContent' aria-expanded='false' aria-label='Toggle navigation'>
      <i class='fas fa-bars'></i>
    </button>
    <div class='collapse navbar-collapse' id='navbarSupportedContent'>
      <ul class='navbar-nav mr-auto mb-2 mb-lg-0'>
        <li class='nav-item'>
          <a class='nav-link active' aria-current='page' routerLink='/ar'>الرئيسيه</a>
        </li>
        <li class='nav-item'>
          <a class='nav-link' routerLink='/allegria-ar'>ألجريا</a>
        </li>
        <li class='nav-item'>
          <a class='nav-link' routerLink='/estate-ar'>Estate</a>
        </li>
        <li class='nav-item'>
          <a class='nav-link' routerLink='/vye-ar'>VYE</a>
        </li>
        <li class='nav-item'>
          <a class='nav-link' routerLink='/eastvale-ar'>إيستفيل</a>
        </li>
        <li class='nav-item'>
          <a class='nav-link' (click)='scroll(contact)'>اتصل بنا</a>
        </li>
        <li class='nav-item'>
          <a class='nav-link' href='tel:+201001040090' dir='ltr'>
            <svg xmlns='http://www.w3.org/2000/svg' width='20.534' height='20.581' viewBox='0 0 20.534 20.581'>
              <path id='Path_41' data-name='Path 41'
                d='M33.868,37.277a12.819,12.819,0,0,1,3.222-4.043.677.677,0,0,1,.9-.075c.375.374,3.446,3.893,3.446,3.893a.743.743,0,0,1-.075.973c-.524.524-2.173,2.1-2.173,2.1a.87.87,0,0,0,.075.973,28.192,28.192,0,0,0,6.368,6.289.852.852,0,0,0,.9.15s1.648-1.722,2.1-2.171a.7.7,0,0,1,.974-.15s3.521,3.07,3.9,3.519a.676.676,0,0,1-.075.9c-1.049,1.048-2.622,2.7-4.046,3.22C44.807,54.573,32.07,41.845,33.868,37.277Zm18.58,11.83c-.45-.449-1.049-.973-1.5-1.348-.6-.524-1.2-1.048-1.723-1.5-.674.6-1.274,1.273-1.948,1.947a1.805,1.805,0,0,1-2.248.075A30.556,30.556,0,0,1,38.439,41.7a1.935,1.935,0,0,1-.15-2.1l.15-.225c.674-.6,1.349-1.273,2.023-1.872-.9-1.048-1.948-2.321-2.922-3.294l-.45.449a11.468,11.468,0,0,0-2.323,2.995c-.375,1.048.524,2.845.974,3.744a29.162,29.162,0,0,0,4.2,5.316A25.719,25.719,0,0,0,45.256,50.9c.9.524,2.772,1.348,3.821.973a12.42,12.42,0,0,0,3-2.321C52.224,49.407,52.3,49.257,52.449,49.108Z'
                transform='translate(-33.396 -32.728)' fill='#31aade' stroke='#31aade' stroke-width='0.5'
                fill-rule='evenodd' />
            </svg>
            <span>+201001040090</span>
          </a>
        </li>
        <li class='nav-item'>
          <a routerLink='/' class='nav-link btn btn-language'>english</a>
        </li>
      </ul>
    </div>
  </div>
</nav>
<main dir='rtl' style='text-align: right'>
  <!-- Start Header -->
  <section class='header'>
    <div class='text'>
      <h2>مجتمع universe</h2>
      <h3>المجتمع الذي يريد الجميع أن يكون جزءًا منه</h3>
    </div>
    <div class='slider-con' dir='ltr'>
      <owl-carousel-o [options]='customOptions'>
        @for (slide of slidesStore; track slide) {
        <ng-template carouselSlide>
          <div class='img-con'>
            <div class='card-img-overlay'></div>
            <div class='img' [ngStyle]="{backgroundImage: 'url(./images/' + slide.src + ')'}"></div>
          </div>
        </ng-template>
        }
      </owl-carousel-o>
    </div>
    <button class='btn'>انضم إلينا</button>
  </section>
  <!-- Start Development -->
  <section #development class='development'>
    <div class='container'>
      <h2 class='text-right text-uppercase'>تطوير</h2>
      <div class='row'>
        <div class='col-md-9 my-auto'>
          <div class='text-con'>
            <h3>كلما عشت أكثر</h3>
            <p>تقدم universe إيست وجهة متكاملة ومتطورة وذات مستوى عالمي في الشرق ، وتقع بين طريقين رئيسيين في القاهرة ،
              القاهرة طريق السويس والقاهرة الإسماعيلية ،
              بجوار مدينة الشروق مباشرة ، وعلى مقربة من العاصمة الإدارية الجديدة. هدفنا هو خلق بيئة حديثة مع التركيز على
              البشر وأنماط حياتهم وتطورهم. تشمل
              مرافق universe إيست مجموعة متنوعة من الأنشطة والخدمات مثل (التعليم الترفيهي ، والرياضة ، والتخييم ، والعافية)
              التي تلبي تجربتك العامة داخل
              منطقتك.</p>
          </div>
        </div>
        <div class='col-md-3 my-auto mt-md-0 mt-3 text-center'>
          <div class='img-con'>
            <img src='../../assets/images/logo.svg' alt='universe logo' class='img-fluid'>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Start Master Plan -->
  <section class='master-plan'>
    <div class='text-con'>
      <div class='container'>
        <h2>الخطة الاساسيه
          <span>والتقسيم</span>
        </h2>
      </div>
    </div>
    <div class='container position-relative h-100' style='z-index: 9;'>
      <div class='utilities'>
        <h3>خدمات</h3>
        <div class='row'>
          <div class='col-md-3 col-sm-6'>
            <ul class='list-unstyled'>
              <li>خدمات الجوار</li>
              <li>البيع بالتجزئة</li>
              <li>مسجد</li>
            </ul>
          </div>
          <div class='col-md-3 col-sm-6'>
            <ul class='list-unstyled'>
              <li>منشأة طبية</li>
              <li>التعليم الطبي الترفيهي / المغامرة</li>
              <li>ثقافة التخييم</li>
            </ul>
          </div>
          <div class='col-md-3 col-sm-6'>
            <ul class='list-unstyled'>
              <li>مركز النقل</li>
              <li>العمود الفقري الأخضر</li>
              <li>العقد الاجتماعية</li>
            </ul>
          </div>
          <div class='col-md-3 col-sm-6'>
            <ul class='list-unstyled'>
              <li>المدرسة / قاعة المدينة</li>
              <li>نادي اجتماعي ورياضي</li>
              <li>إدارة المرافق</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Start Video Slider -->
  <section class='video-slider' dir='ltr'>
    <owl-carousel-o [options]='videOptions'>
      <ng-template carouselSlide>
        <div class='con'>
          <div class='img-con' style='background-image: url(../../assets/images/Untitled-2-06.png);'></div>
        </div>
      </ng-template>
      <ng-template carouselSlide>
        <div class='con'>
          <video id='video' width='100%' height='100%' poster='../../assets/images/Untitled-2-04.png'>
            <source src='../../assets/video.mp4' type='video/mp4'>
          </video>
          <button class='btn' id='videoBtn' (click)='playPause()'>
            @if (play;) {
            <i class='fas fa-play-circle'></i>
            }
            @if (!play;) {
            <i class='fas fa-pause-circle'></i>
            }
          </button>
        </div>
      </ng-template>
      <ng-template carouselSlide>
        <div class='con'>
          <video id='video2' width='100%' height='100%' poster='../../assets/images/Untitled-2-04.png'>
            <source src='../../assets/video2.mp4' type='video/mp4'>
          </video>
          <button class='btn' id='videoBtn2' (click)='playPause2()'>
            @if (play;) {
            <i class='fas fa-play-circle'></i>
            }
            @if (!play;) {
            <i class='fas fa-pause-circle'></i>
            }
          </button>
        </div>
      </ng-template>
    </owl-carousel-o>
  </section>
  <!-- Start The Big Slider -->
  <section id='big-slider'>
    <div class='container'>
      <div class='row'>
        <div class='col-md-12'>
          <h2>
            انواع
            <span>الوحدات</span>
          </h2>
          <div>
            <ul class='list-unstyled'>
              <li id='project1' class='active' (click)="viewSlider('1')">LV</li>
              <li id='project2' (click)="viewSlider('2')">MV</li>
              <li id='project3' (click)="viewSlider('3')">SV</li>
              <li id='project7' (click)="viewSlider('7')">XV</li>
              <li id='project8' (click)="viewSlider('8')">RV</li>
              <li id='project5' (click)="viewSlider('5')">Twin House</li>
              <li id='project4' (click)="viewSlider('4')">Town House</li>
              <li id='project6' (click)="viewSlider('6')">Tr</li>
            </ul>
            <div class='clearfix'></div>
          </div>
          <div #project id='projectttt' class='projects project-one w-100 my-4'>
            <img src='./assets/images/lv1.png' class='img-fluid m-2' alt=''>
            <img src='./assets/images/lv2.png' class='img-fluid m-2' alt=''>
            <img src='./assets/images/lv3.png' class='img-fluid m-2' alt=''>
            <img src='./assets/images/lv4.png' class='img-fluid m-2' alt=''>
          </div>
        </div>
      </div>
    </div>

  </section>
  <!-- Start About & Contact -->
  <section class='last-section'>
    <div class='container'>
      <div class='row'>
        <div class='col-md-12'>
          <section class='about'>
            <h2>
              عن
              <span>universe</span>
            </h2>
            <p>بناء تاريخ لأكثر من عقدين من العمليات الناجحة في مصر ، universe هي واحدة من التطوير العقاري الرائدة في
              البلاد الشركات. يقع المقر الرئيسي في القاهرة
              والمدرجة في البورصة المصرية ، universe تقدم إلى السوق مشاريع واسعة النطاق حائزة على جوائز ، تلبية احتياجات
              مصر المتزايدة باستمرار من المساكن عالية
              الجودة والمساحات التجارية والتجزئة. نحن نفخر بأنفسنا لشغفنا بالتميز و الالتزام بتعزيز العلاقات طويلة الأمد
              مع عملائنا ومساهمينا وشركاء الأعمال
              والموظفين ، مما ساعدنا على النمو إلى شركة نحن اليوم.</p>
          </section>
          <!-- Start Contact -->
          <section #contact class='contact'>
            <h2>
              اتصل
              <span>بنا</span>
            </h2>
            <form [formGroup]='updateForm' (ngSubmit)='onSubmit()'>
              <div class='row'>
                <div class='col-md-6 mb-4'>
                  <input type='text' placeholder='الاسم بالكامل' title='الاسم بالكامل' class='form-control'
                    formControlName='name'>
                  <app-field-error [displayError]="isFieldValid('name')" errorMsg='يرجى إدخال اسمك'></app-field-error>
                </div>
                <div class='col-md-6 mb-4'>
                  <input type='text' placeholder='البريد الالكترونى' title='البريد الالكترونى' class='form-control'
                    formControlName='email'>
                  <app-field-error [displayError]="isFieldValid('email')"
                    errorMsg='يرجى ادخال بريد الكترونى صحيح'></app-field-error>
                </div>
                <div class='col-md-12 mb-4'>
                  <input type='text' placeholder='رقم الهاتف' title='رقم الهاتف' class='form-control'
                    formControlName='phone'>
                  <app-field-error [displayError]="isFieldValid('phone')"
                    errorMsg='يرجى إدخال رقم هاتف صحيح'></app-field-error>
                </div>
                <div class='col-md-12 mb-4'>
                  <textarea name='Message' title='الرساله' placeholder='الرساله' class='form-control'
                    formControlName='notes'></textarea>
                  <app-field-error [displayError]="isFieldValid('notes')"
                    errorMsg='يجد الا يقل عدد الحروف عن 20 حرفا'></app-field-error>
                </div>
                <div class='col-md-12'>
                  <button type='submit' class='btn btn-block' [disabled]='submitted'>إرسال</button>
                </div>
              </div>
            </form>
          </section>
        </div>
      </div>
    </div>
  </section>
</main>
<!-- Start Footer -->
<footer dir='rtl'>
  <div class='container'>
    <div class='row'>
      <div class='col-md-auto my-auto'>
        <h6>اتصل بنا</h6>
        <div class='details'>
          <div>
            <a href='tel:+201001040090'>+201001040090</a>
          </div>
          <div>السبت-الخميس 9 صباحاً-6 مساءاً</div>
          <div class='social'>
            <ul class='list-unstyled'>
              <li>
                <a href='#'>
                  <svg xmlns='http://www.w3.org/2000/svg' width='12.447' height='23.239' viewBox='0 0 12.447 23.239'>
                    <path id='Icon_awesome-facebook-f' data-name='Icon awesome-facebook-f'
                      d='M13.24,13.072l.645-4.206H9.85V6.137a2.1,2.1,0,0,1,2.371-2.272h1.835V.284A22.373,22.373,0,0,0,10.8,0C7.476,0,5.3,2.014,5.3,5.661V8.866H1.609v4.206H5.3V23.239H9.85V13.072Z'
                      transform='translate(-1.609)' />
                  </svg>
                </a>
              </li>
              <li>
                <a href='#'>
                  <svg xmlns='http://www.w3.org/2000/svg' width='19.003' height='13.362' viewBox='0 0 19.003 13.362'>
                    <path id='Icon_awesome-youtube' data-name='Icon awesome-youtube'
                      d='M19.656,6.591A2.388,2.388,0,0,0,17.976,4.9a56.428,56.428,0,0,0-7.424-.4,56.428,56.428,0,0,0-7.424.4,2.388,2.388,0,0,0-1.68,1.691,25.048,25.048,0,0,0-.4,4.6,25.048,25.048,0,0,0,.4,4.6,2.352,2.352,0,0,0,1.68,1.664,56.428,56.428,0,0,0,7.424.4,56.428,56.428,0,0,0,7.424-.4,2.352,2.352,0,0,0,1.68-1.664,25.049,25.049,0,0,0,.4-4.6,25.049,25.049,0,0,0-.4-4.6ZM8.608,14.02V8.369l4.967,2.826L8.608,14.02Z'
                      transform='translate(-1.05 -4.5)' />
                  </svg>
                </a>
              </li>
              <li>
                <a href='#'>
                  <svg xmlns='http://www.w3.org/2000/svg' width='18.186' height='18.186' viewBox='0 0 18.186 18.186'>
                    <path id='Icon_awesome-linkedin' data-name='Icon awesome-linkedin'
                      d='M16.887,2.25H1.295A1.3,1.3,0,0,0,0,3.561V19.125a1.3,1.3,0,0,0,1.295,1.311H16.887a1.308,1.308,0,0,0,1.3-1.311V3.561A1.308,1.308,0,0,0,16.887,2.25ZM5.5,17.838H2.8V9.159H5.5v8.679ZM4.149,7.974A1.563,1.563,0,1,1,5.712,6.411,1.564,1.564,0,0,1,4.149,7.974ZM15.6,17.838H12.9V13.616c0-1.007-.02-2.3-1.4-2.3-1.4,0-1.62,1.1-1.62,2.229v4.295h-2.7V9.159H9.775v1.185h.037a2.839,2.839,0,0,1,2.553-1.4c2.728,0,3.235,1.8,3.235,4.137Z'
                      transform='translate(0 -2.25)' />
                  </svg>
                </a>
              </li>
              <li>
                <a href='#'>
                  <svg xmlns='http://www.w3.org/2000/svg' width='19.003' height='15.434' viewBox='0 0 19.003 15.434'>
                    <path id='Icon_awesome-twitter' data-name='Icon awesome-twitter'
                      d='M17.05,7.227c.012.169.012.338.012.506A11.005,11.005,0,0,1,5.981,18.815,11.006,11.006,0,0,1,0,17.066a8.057,8.057,0,0,0,.941.048,7.8,7.8,0,0,0,4.835-1.664,3.9,3.9,0,0,1-3.641-2.7,4.912,4.912,0,0,0,.736.06,4.119,4.119,0,0,0,1.025-.133A3.9,3.9,0,0,1,.772,8.855V8.807a3.922,3.922,0,0,0,1.76.494A3.9,3.9,0,0,1,1.326,4.092,11.071,11.071,0,0,0,9.357,8.168a4.4,4.4,0,0,1-.1-.892A3.9,3.9,0,0,1,16,4.611a7.668,7.668,0,0,0,2.472-.941A3.884,3.884,0,0,1,16.76,5.816,7.808,7.808,0,0,0,19,5.214,8.372,8.372,0,0,1,17.05,7.227Z'
                      transform='translate(0 -3.381)' />
                  </svg>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class='col-md mx-auto text-center my-md-auto my-3'>
        <img src='../../assets/images/logo.svg' alt='Logo' class='img-fluid'>
      </div>
      <div class='col-md-auto ml-auto my-auto'>
        <h6>الشركة</h6>
        <nav>
          <ul class='list-unstyled'>
            <li>
              <a href='#'>تطوير</a>
            </li>
            <li>
              <a href='#'>خدمات</a>
            </li>
            <li>
              <a href='#'>المعرض</a>
            </li>
            <li>
              <a href='#'>المشاريع</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</footer>